import { Component, OnDestroy, OnInit } from "@angular/core";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { BudgetWizardService } from "../services/budget.wizard.service";
import { formatDate } from "src/app/services/date/date-format";
import { Budget } from "src/app/model/budget/budget";
import { Subscription } from "rxjs";

@Component({
  selector: "app-budget-order-list",
  templateUrl: "./budget-order-list.component.html",
  styleUrls: ["./budget-order-list.component.css"],
})
export class BudgetOrderListComponent implements OnInit, OnDestroy {
  loading = false;
  budgets: Budget[] = [];
  currentBudget: Budget;

  private currentBudgetSuscripcion: Subscription;
  private budgetsSuscripcion: Subscription;

  constructor(
    private service: BudgetWizardService,
    private confirmDialogService: ConfirmDialogService
  ) {}

  ngOnInit() {
    this.currentBudgetSuscripcion = this.service.currentBudget$.subscribe(
      (budget) => {
        if (budget) {
          this.currentBudget = budget;
        }
      }
    );

    this.budgetsSuscripcion = this.service.budgets$.subscribe((budgets) => {
      this.budgets = budgets;
    });
  }

  isSelected(budget: Budget) {
    return this.currentBudget === budget;
  }

  async finish() {
    if (this.service.isCurrentAppointmentValid()) {
      const confirm = await this.confirmDialogService
        .confirm(
          "Presupuesto",
          "¿Esta seguro que desea crear el presupuesto <b>" +
            this.service.currentBudget.Name +
            "</b>? <p> Vigencia hasta <b>" +
            formatDate(this.service.currentBudget.FinalizeDate) +
            "</b></p>",
          "Finalizar",
          "Cancelar"
        )
        .toPromise();
      if (confirm) {
        this.loading = true;
        await this.service.finish();
        this.loading = false;
      }
    }
  }

  async addBudget() {
    this.loading = true;
    await this.service.addNewBudget();
    this.loading = false;
  }

  remove(budget: Budget) {
    this.service.remove(budget);
  }

  setCurrentBudget(budget: Budget) {
    this.service.setCurrent(budget);
  }

  getName(budget: Budget) {
    return budget.Name && budget.Name !== "" ? `${budget.Name}` : "Editando...";
  }

  ngOnDestroy(): void {
    if (this.currentBudgetSuscripcion) {
      this.currentBudgetSuscripcion.unsubscribe();
    }

    if (this.budgetsSuscripcion) {
      this.budgetsSuscripcion.unsubscribe();
    }
  }
}
